import { render, staticRenderFns } from "./OrmBatchingView.vue?vue&type=template&id=53e6547d"
import script from "./OrmBatchingView.vue?vue&type=script&lang=js"
export * from "./OrmBatchingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports